"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaintenancePage = void 0;
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const react_router_1 = require("react-router");
const react_i18next_1 = require("react-i18next");
const MaintenancePage = (props) => {
    const { t } = (0, react_i18next_1.useTranslation)('auth');
    return (react_1.default.createElement("div", null,
        t('auth:Maintenance'),
        react_1.default.createElement("br", null),
        react_1.default.createElement(react_router_1.Link, { to: props.linkPath ? props.linkPath : '/home' }, t('auth:BackToHomePage'))));
};
exports.MaintenancePage = MaintenancePage;
exports.default = exports.MaintenancePage;
//# sourceMappingURL=MaintenancePage.js.map